import { createIdentifier } from '@blocksuite/global/di';
import type { Signal } from '@preact/signals-core';

export interface LocaleService {
  readonly language$: Signal<string>;

  translate(
    key: string,
    fallback: string,
    options?: Record<string, unknown>
  ): string;
}

export const LocaleProvider = createIdentifier<LocaleService>(
  'AffineLocaleService'
);

export function getBlocksuiteLocaleKey(scope: string, value: string) {
  return `com.affine.blocksuite.${scope}.${value}`;
}

export function translateBlocksuiteText(
  locale: LocaleService | null | undefined,
  key: string,
  fallback: string
) {
  if (!locale) return fallback;

  return locale.translate(key, fallback, {
    lng: locale.language$.value,
  });
}

/**
 * Resolve a stable context key first, then fall back to a key based on the
 * original English UI text. The second key keeps older and third-party
 * toolbar configurations localizable without changing their action ids.
 */
export function translateBlocksuiteTextWithTextFallback(
  locale: LocaleService | null | undefined,
  key: string,
  fallback: string,
  textScope: string
) {
  const translated = translateBlocksuiteText(locale, key, fallback);
  if (translated !== fallback) return translated;

  return translateBlocksuiteText(
    locale,
    getBlocksuiteLocaleKey(`${textScope}.text`, fallback),
    fallback
  );
}
